import { P } from '@dnb/eufemia';

import Dot from '@/components/Dot';

import style from './index.module.css';

export default function AppStatusDescription() {
  return (
    <div className={style['StatusContainer']}>
      <div className={style['StatusRow']}>
        <Dot right="small" />
        <P> - App has attached integration services with Live environment access</P>
      </div>
    </div>
  );
}
